import React from "react";
import { BrowserRouter, Routes, Route} from "react-router-dom";
import Login from "../view/Login";
import Register from "../view/Register";
import Quotes from "../view/Quotes";
import { LoginContextProvider }  from '../Context/Logincontext'
import Client from "../view/Client";
import Users from "../view/Users";
import Add from "../view/Admin/Add";
import Products from "../view/Products";
import AddClient from "../view/AddClient";
import AddQuotes from "../view/AddQuotes";
import AddBills from "../view/AddBills";
import Pdf from "../Component/Hooks/PdfMarmol/Pdf";
import AddCompany from "../view/AddCompany";
import Config from "../view/Config";
import Texture from "../view/Texture";
import AddTexture from "../view/AddTexture";
import AddProduct3D from "../view/AddProduct3D";
import MenuConfig from "../view/Admin/MenuConfig";
import CompanyView from "../view/Admin/CompanyView";
import Prueba from "../view/prueba";
import BarraConSalpicadero from "../json/BarraConSalpicadoro";
import Barra from "../json/Barra";
import Circulo from "../json/Circulo";
import CirculoGrande from "../json/CirculoGrande";
import MesaenL from "../json/MesaenL";
import MesaenLGrande from "../json/MesonenLGrande";
import AddTest from "../view/Admin/Add";
import ForgottenPassword from "../view/ForgottenPassword";
import Bills from "../view/Bills";
import Contribution from "../Component/Hooks/Bill/Contribution";
import AddTable from "../view/Admin/AddTables";
import AddUserAdmin from "../view/Admin/AddUserAdmin";
import Employees from "../view/Employees";
import AddEmployee from "../view/AddEmployee";
import CompanyInfo from "../view/CompanyInfo";
import Inventory from "../view/Inventory";
import AddInventory from "../view/AddInventory";
import Suppliers from "../view/Suppliers";
import AddSuppliers from "../view/AddSuppliers"
import CompositeProduct from "../view/CompositeProduct";
import AddCompositeProduct from "../view/AddCompositeProduct";
import AddProduct from "../view/AddProduct";

function Router() {

    return (
        <>
            <LoginContextProvider>
                <BrowserRouter>
                    <Routes>
                        <Route exact index element={<Login/>}/>
                        <Route exact path="/ajustes" element={<Config />} />
                        <Route exact path="/Pruebas" element={<AddTest />} />
                        <Route exact path="/Agregar_Textura" element={<AddTexture />} />
                        <Route exact path="/Texturas" element={<Texture />} />
                        <Route exact path="/Crear_Empresa" element={<AddCompany />} />
                        <Route exact path="/Login" element={<Login />} />
                        <Route exact path="/Registrar" element={<Register />} />
                        <Route exact path="/Informacion_Empresa" element={<CompanyInfo />} />
                        <Route exact path="/Inventario" element={<Inventory />} />
                        <Route exact path="/Cotizaciones" element={<Quotes />} />
                        <Route exact path="/Empleados" element={<Employees />} />
                        <Route exact path="/Facturas" element={<Bills />} />
                        <Route exact path="/Clientes" element={<Client />} />
                        <Route exact path="/Usuarios" element={<Users />} /> 
                        <Route exact path="/Productos" element={<Products />} /> 
                        <Route exact path="//Agregar_Proveedor" element={<AddSuppliers />} /> 
                        <Route exact path="/Proveedores" element={<Suppliers />} />                                 
                        <Route exact path="/Agregar" element={<Add />} />  
                        <Route exact path="/Agregar_Clientes" element={<AddClient />} />   
                        <Route exact path="/Agregar_Inventario" element={<AddInventory />} />   
                        <Route exact path="/Agregar_Admin" element={<AddUserAdmin />} />                 
                        <Route exact path="/Agregar_Productos" element={<AddProduct3D />} /> 
                        <Route exact path="/Agregar_Empleado" element={<AddEmployee />} /> 
                        <Route exact path="Menu_Configuracion" element={<MenuConfig />} />  
                        <Route exact path="/Empresas" element={<CompanyView />} />  
                        <Route exact path="/RecuperarContraseña" element={<ForgottenPassword />} />  
                        <Route exact path="/Agregar_Cotizacion" element={<AddQuotes />} /> 
                        <Route exact path="/Agregar_Factura" element={<AddBills />} /> 
                        <Route exact path="/Cuenta_Cobro" element={<Contribution />} /> 
                        <Route exact path="/Cuenta_Cobro" element={<Contribution />} /> 
                        <Route exact path="/Agregar_Tabla" element={<AddTable />} /> 
                        <Route exact path="/VistapreviaPdf" element={<Pdf />} />
                        <Route exact path="/Barraconsalpicadero" element={<BarraConSalpicadero />} />
                        <Route exact path="/Barra" element={<Barra />} />
                        {/* <Route exact path="/Circulo" element={<Circulo />} /> */}
                        <Route exact path="/Mesaredonda" element={<CirculoGrande />} />
                        {/* <Route exact path="/Mesaenl" element={<MesaenL />} /> */}
                        <Route exact path="/Mesaenlgrande" element={<MesaenLGrande />} />
                        <Route exact path="/Iniciar_Sesión" element={<Login />} />            
                        <Route exact path="/Producto_Compuesto" element={<CompositeProduct />} />
                        <Route exact path="/Crear_Producto_Compuesto" element={<AddCompositeProduct />} />
                        <Route exact path="/Crear_Producto" element={<AddProduct />} />
                    </Routes>
                </BrowserRouter> 
            </LoginContextProvider>
        </>
    );
}
  
export default Router;